var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-fixed"},[_c('detail-page',{attrs:{"item":_vm.dataList,"index":_vm.nowIndex,"dataleng":_vm.dataList.length,"type":"video"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }